export default __webpack_public_path__ + "static/media/rep.b87c15f0.svg";